type RenderStat = {
  count: number
  last: number
  totalTime: number
}

const renderStats = new Map<string, RenderStat>()

export function trackRender(name: string) {
  const now = performance.now()

  const prev = renderStats.get(name) || {
    count: 0,
    last: now,
    totalTime: 0,
  }

  const diff = now - prev.last

  renderStats.set(name, {
    count: prev.count + 1,
    last: now,
    totalTime: prev.totalTime + diff,
  })
}

export function getStats() {
  return Array.from(renderStats.entries())
    .map(([name, data]) => ({
      name,
      renders: data.count,
      totalTime: data.totalTime,
      avgTime: data.totalTime / data.count,
    }))
    .sort((a, b) => b.totalTime - a.totalTime)
}

export function resetStats() {
  renderStats.clear()
}